<template>
	<div class="ReTreeSearchDrop">
		<base-input
			:name="name"
			:placeholder="placeholder"
			addon-left-icon="tim-icons icon-zoom-split"
			v-model="value.inputText"
			@keyup="getSearch"
			autocomplete="off"
		>
		</base-input>
		<ul v-if="bInSearch" class="my-0 mb-1 w-100 dropdown-menu show">
			<li class="searchProg dropdown-item cursor-pointer">Поиск данных <i class="tim-icons icon-refresh-02 rotate"></i></li>
		</ul>
		<re-tree v-if="masTree.length > 0" :class="[{'show':masTree.length > 0},]" v-click-outside="hide" class="my-0 mb-1 dropdown-menu"
			:treeData="masTree"
			:NotFolderClick="TreeSetElementModel"
			:OverightAllClick="TreeSetElementModel"
			:curentpath="cp"
			:filter_str="value.inputText"
		/>
	</div>
</template>

<script>
	import ReTree from 'src/our_components/Tree/ReTree.vue';
	export default {
		name: 'ReTreeSearchDrop',
		components: {
			ReTree 
		},
		props: {
			placeholder: String,
			name: String,
			MinTxtLen: {
				type: Number,
				default:2,
			},
			value: {
				type: Object,
				default() {	return {
					inputText: '',
					selectedVal:''
				}; }
			},
			strType:{
				type: String,
				default: 'departments',
			}
		},
		data () {
			return {
				ver: 1,
				inputText: '',
				bInSearch: false,
				iApiCallCnt: 0,
				masDataOpt: [],
				masTree:[],
				cp:[],
			}
		},
		computed: {

		},
		methods: {
			getTree(){
				if(this.strType == 'staff'){
					this.masTree = this.$GVO.masTreeOrgStructWithStaff;
				}else{
					this.masTree = this.$GVO.masTreeOrgStruct;
				}
			},
			TreeSetElementModel(opt){
				//console.log('TreeSetElementModel',opt);
				this.value.inputText = opt.name;
				this.value.selectedVal = opt.id;
				this.$emit('input', {inputText:opt.name,selectedVal:opt.id});
				this.$emit('change',{inputText:opt.name,selectedVal:opt.id});
				this.masTree = [];
			},
			getSearch(ev){
				if (this.value.inputText.length > this.MinTxtLen){
					this.bInSearch = true;
					this.iApiCallCnt++;
					let iCurApiCallCnt = this.iApiCallCnt;
					if (this.value.inputText.length > this.MinTxtLen){
						if (iCurApiCallCnt == this.iApiCallCnt){
							this.getTree();
							this.bInSearch = false;
							this.iApiCallCnt = 0;
						}
					}else{
						if (iCurApiCallCnt == this.iApiCallCnt) {
							this.bInSearch = false;
							this.masTree = [];
						}
					}
				}else{
					this.bInSearch = false;
					this.masTree = [];
				}
			},
			hide(){
				this.masTree = [];
			}
		},
	}
</script>
<style scoped>
	.dropdown-menu{ 
		/*
		max-height: 400px; 
		overflow-y: auto;
		*/
		width: calc(100% - 30px);
		left: 15px;
	}
	.ReTreeSearchDrop {
	position: relative;
	}
	.ReTreeSearchDrop ul{
		width: max-content;
	}
</style>
